module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a3d"
  }, [_c('div', {
    staticClass: "file job",
    on: {
      "click": function($event) {
        return _vm.toggleJobs(_vm.job.jobPathKey, _vm.job.sourceFilePathKey)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1em",
      "height": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-name-block"
  }, [(_vm.job.isNested) ? _c('div', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.job.nestedJobName))]) : _c('div', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.job.filename))]), _vm._v(" "), _c('div', {
    staticClass: "file-date"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.job.createdAt)))])]), _vm._v(" "), (!_vm.job.parentPathKey) ? [(!_vm.job.isArchived) ? _c('div', {
    staticStyle: {
      "align-self": "center"
    }
  }, [_c('button', {
    staticClass: "a3d btn small inv",
    attrs: {
      "disabled": _vm.archivingProcess[_vm.job.jobPathKey]
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.archiveJob({
          jobPathKey: _vm.job.jobPathKey
        })
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.archivingProcess[_vm.job.jobPathKey] ? 'Archiving...' : 'Archive') + "\n                ")])]) : _c('div', {
    staticStyle: {
      "align-self": "center"
    }
  }, [_c('button', {
    staticClass: "a3d btn small inv",
    attrs: {
      "disabled": _vm.unarchivingProcess[_vm.job.jobPathKey]
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.unarchiveJob({
          jobPathKey: _vm.job.jobPathKey
        })
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.unarchivingProcess[_vm.job.jobPathKey] ? 'Unarchiving...' : 'Unarchive') + "\n                ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "toggleIcon"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-up': _vm.isOpen, 'fa-chevron-down': !_vm.isOpen
    }
  })])], 2), _vm._v(" "), (_vm.isLoading || _vm.archivingProcess[_vm.job.jobPathKey] || _vm.unarchivingProcess[_vm.job.jobPathKey]) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.job.jobOutputs), function(jobOutput, joI) {
    return (_vm.isOpen && _vm.job.hasOwnProperty('jobOutputs')) ? _c('div', {
      key: joI,
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_c('div', {
      staticClass: "job jobout",
      on: {
        "click": function($event) {
          return _vm.toggleJobsFiles(joI, jobOutput)
        }
      }
    }, [(_vm.compareMode && _vm.isHasCost(jobOutput.outputFiles, _vm.job)) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('input', {
      staticClass: "filled-in",
      attrs: {
        "type": "checkbox",
        "id": jobOutput.jobOutputPathKey
      },
      domProps: {
        "checked": _vm.isCheckedToCompare(jobOutput.jobOutputPathKey)
      },
      on: {
        "change": function($event) {
          return _vm.toggleJobCompare({
            jobOutput: jobOutput,
            job: _vm.job
          })
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": jobOutput.jobOutputPathKey
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.subscription || jobOutput.paidfor || _vm.job.isNested) ? _c('div', {
      staticStyle: {
        "flex": "3",
        "font-size": "1.2em"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId, false)) + "\n            ")]) : _vm._e(), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && (_vm.subscription || jobOutput.paidfor) && _vm.job.isNested) ? _c('div', {
      staticClass: "jobout-buttons nested-row"
    }, [_c('div', {
      staticClass: "jobout-buttons-row"
    }, [(_vm.job.isNested) ? _c('router-link', {
      staticClass: "a3d btn inv small",
      attrs: {
        "to": {
          name: 'ThreeJSViewer',
          params: {
            id: jobOutput.id,
            type: 'output'
          }
        }
      }
    }, [_vm._v("\n                        View\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.isHasCost(jobOutput.outputFiles, _vm.job)) ? _c('button', {
      staticClass: "a3d btn inv small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showEstimateModal({
            jobOutput: jobOutput,
            job: _vm.job
          })
        }
      }
    }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), (_vm.isHasConfigJson(jobOutput.outputFiles)) ? _c('button', {
      staticClass: "a3d btn inv small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.fileDownload($event, {
            filename: _vm.isHasConfigJson(jobOutput.outputFiles),
            sourceFilePathKey: _vm.job.sourceFilePathKey,
            jobPathKey: _vm.job.jobPathKey,
            jobOutputPathKey: jobOutput.jobOutputPathKey,
            newTab: true
          })
        }
      }
    }, [_vm._v("Download config")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && (jobOutput.paidfor || _vm.subscription) && !_vm.job.isNested) ? _c('div', {
      staticClass: "jobout-buttons"
    }, [(_vm.isHasOutput(jobOutput.outputFiles)) ? _c('div', {
      staticClass: "jobout-buttons-row"
    }, [_c('router-link', {
      staticClass: "a3d btn inv small",
      attrs: {
        "to": {
          name: 'ThreeJSViewer',
          params: {
            id: jobOutput.id,
            type: 'output'
          }
        }
      }
    }, [_vm._v("\n                        View\n                    ")]), _vm._v(" "), (_vm.isHasLog(jobOutput.outputFiles)) ? _c('button', {
      staticClass: "right a3d btn small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.fileDownload($event, {
            filename: _vm.isHasLog(jobOutput.outputFiles),
            sourceFilePathKey: _vm.job.sourceFilePathKey,
            jobPathKey: _vm.job.jobPathKey,
            jobOutputPathKey: jobOutput.jobOutputPathKey,
            newTab: true
          })
        }
      }
    }, [_vm._v("Download optimization log")]) : _vm._e(), _vm._v(" "), (_vm.isHasConfigJson(jobOutput.outputFiles)) ? _c('button', {
      staticClass: "right a3d btn small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.fileDownload($event, {
            filename: _vm.isHasConfigJson(jobOutput.outputFiles),
            sourceFilePathKey: _vm.job.sourceFilePathKey,
            jobPathKey: _vm.job.jobPathKey,
            jobOutputPathKey: jobOutput.jobOutputPathKey,
            newTab: true
          })
        }
      }
    }, [_vm._v("Download config")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isHasOutput(jobOutput.outputFiles)) ? _c('div', {
      staticClass: "jobout-buttons-row"
    }, [_c('router-link', {
      staticClass: "a3d btn inv small",
      attrs: {
        "to": {
          name: 'ThreeJSViewer',
          params: {
            id: jobOutput.id,
            type: 'output'
          },
          query: {
            modifySupports: true
          }
        }
      }
    }, [_vm._v("Modify Supports")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.subscription && !jobOutput.paidfor && !_vm.job.isNested) ? [_c('div', {
      staticStyle: {
        "flex-grow": "1",
        "padding-top": "1px",
        "margin-left": "30px"
      }
    }, [_c('i', [_vm._v(_vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId)))]), _vm._v("\n                    is not yet unlocked.\n                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1",
        "flex-basis": "50%",
        "align-self": "center"
      }
    }, [(_vm.user.credits.length > 0) ? _c('button', {
      staticClass: "right a3d btn small inv",
      staticStyle: {
        "margin-right": "0.5em"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unlockJob($event, jobOutput, _vm.job)
        }
      }
    }, [_vm._v("Unlock"), _c('br'), _vm._v("(1 credit)\n                    ")]) : _c('a', {
      staticClass: "a3d btn small right",
      on: {
        "click": _vm.buymodal
      }
    }, [_vm._v("Buy Subscription")])])] : _vm._e(), _vm._v(" "), (_vm.subscription || jobOutput.paidfor || _vm.job.isNested) ? _c('div', {
      staticClass: "toggleIcon"
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-chevron-up': _vm.jobsFilesToggle[joI], 'fa-chevron-down': !_vm.jobsFilesToggle[joI]
      }
    })]) : _vm._e()], 2), _vm._v(" "), (_vm.jobsFilesToggle[joI] && (_vm.subscription || jobOutput.paidfor || _vm.job.isNested)) ? [(jobOutput.outputFiles && jobOutput.outputFiles.length > 0) ? _c('div', _vm._l((jobOutput.outputFiles), function(outputFile, ofI) {
      return (!outputFile.name.match(/\.json$/)) ? _c('div', {
        key: ofI,
        staticStyle: {
          "margin-left": "40px"
        }
      }, [(outputFile.name.match(/^1_.*_0m\.stl$/) &&
        !outputFile.name.match(/_compensated_0m\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [(outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Support Structure Renishaw\n                        ")]) : (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Support Structure Polymer \n                        ")]) : (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Strengthening support\n                        ")]) : (!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Support Structure\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [(!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) && !outputFile.name.match(/^1_magicSupp_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('dropdown', {
        attrs: {
          "position": ['center', 'top', 'center', 'top'],
          "visible": !!(_vm.jobsFilesSupportVisible[joI])
        },
        on: {
          "clickout": function($event) {
            return _vm.visibleJobsFilesSupport(joI, false)
          }
        }
      }, [_c('div', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.visibleJobsFilesSupport(joI, true)
          }
        }
      }, [_vm._v("\n                                    Download "), _c('i', {
        staticClass: "fa fa-angle-down"
      })]), _vm._v(" "), _c('div', {
        staticClass: "dialog no-padding",
        attrs: {
          "slot": "dropdown"
        },
        slot: "dropdown"
      }, [_c('aside', {
        staticClass: "menu"
      }, [_c('ul', {
        staticClass: "menu-list"
      }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
        return (outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/) &&
          !outputFileNested.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) &&
          !outputFileNested.name.match(/^1_magicSupp_0m\.stl$/) &&
          !outputFileNested.name.match(/^1_polymerSupp.*_0m\.stl$/) &&
          !outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/)) ? _c('li', {
          key: ofNI
        }, [_c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              _vm.fileDownload($event, {
                filename: outputFileNested.name,
                sourceFilePathKey: _vm.job.sourceFilePathKey,
                jobPathKey: _vm.job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              });
              _vm.visibleJobsFilesSupport(joI, false)
            }
          }
        }, [_vm._v("\n                                                    Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                ")])]) : _vm._e()
      }), 0)])])]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
        staticClass: "a3d btn small nowrap",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("\n                              Download STL\n                            ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
        staticClass: "a3d btn small nowrap",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("\n                              Download STL\n                            ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
        staticClass: "a3d btn small nowrap",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("\n                              Download STL\n                            ")]) : _vm._e()], 1)]) : (outputFile.name.match(/(.*)_output\.stl$/) || outputFile.name.match(/(.*)_new\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Oriented Part\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [(_vm.isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)) ? _c('button', {
        staticClass: "a3d btn inv small",
        on: {
          "click": function($event) {
            return _vm.showEstimateCost($event, {
              filename: 'cost.json',
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), _c('dropdown', {
        attrs: {
          "position": ['center', 'top', 'center', 'top'],
          "visible": !!(_vm.jobsFilesPartVisible[joI])
        },
        on: {
          "clickout": function($event) {
            return _vm.visibleJobsFilesPart(joI, false)
          }
        }
      }, [_c('div', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.visibleJobsFilesPart(joI, true)
          }
        }
      }, [_vm._v("\n                                    Download "), _c('i', {
        staticClass: "fa fa-angle-down"
      })]), _vm._v(" "), _c('div', {
        staticClass: "dialog no-padding",
        attrs: {
          "slot": "dropdown"
        },
        slot: "dropdown"
      }, [_c('aside', {
        staticClass: "menu"
      }, [_c('ul', {
        staticClass: "menu-list"
      }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
        return (outputFileNested.name.match(/^(.*)_output\.(?!(txt)$)([^.]{3}$)/) || outputFileNested.name.match(/^.*_new\.[\S]{3}$/)) ? _c('li', {
          key: ofNI
        }, [_c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              _vm.fileDownload($event, {
                filename: outputFileNested.name,
                sourceFilePathKey: _vm.job.sourceFilePathKey,
                jobPathKey: _vm.job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              });
              _vm.visibleJobsFilesPart(joI, false)
            }
          }
        }, [_vm._v("\n                                                    Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                ")])]) : _vm._e()
      }), 0)])])])], 1)]) : (outputFile.name.match(/plate_[0-9]+\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Build plate #" + _vm._s(Number(outputFile.name.match(/plate_([0-9]+)\.stl$/)[1])) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [_c('button', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("Download")])])]) : (outputFile.name.match(/support[0-9]+\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Build plate supports #" + _vm._s(Number(outputFile.name.match(/support([0-9]+)\.stl$/)[1])) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [_c('button', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("Download")])])]) : _vm._e()]) : _vm._e()
    }), 0) : _c('div', [_c('div', {
      staticStyle: {
        "margin-left": "40px"
      }
    }, [_c('div', {
      staticClass: "job jobout job-status"
    }, [_c('div', {
      staticClass: "job-status-message"
    }, [_vm._v("\n                            " + _vm._s(_vm.displayMessage(jobOutput.status)) + "\n                            "), (jobOutput.status === 'PROCESSING') ? _c('span', [_vm._v(_vm._s(jobOutput.progress) + "%")]) : _vm._e()]), _vm._v(" "), (jobOutput.status === 'PROCESSING') ? _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "determinate",
      style: ({
        width: jobOutput.progress + '%'
      })
    })]) : _vm._e(), _vm._v(" "), _vm._m(0, true)])])])] : _vm._e(), _vm._v(" "), (_vm.isHasCompensated(jobOutput.outputFiles) && (_vm.subscription || jobOutput.paidfor)) ? _c('div', {
      staticClass: "job jobout",
      on: {
        "click": function($event) {
          return _vm.toggleJobsFilesCompensated(joI)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "3",
        "font-size": "1.2em"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId, true)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "jobout-buttons"
    }, [_c('div', {
      staticClass: "jobout-buttons-row"
    }, [_c('router-link', {
      staticClass: "a3d btn inv small",
      attrs: {
        "to": {
          name: 'ThreeJSViewer',
          params: {
            id: jobOutput.id,
            type: 'output'
          },
          query: {
            compensated: true
          }
        }
      }
    }, [_vm._v("\n                        View\n                    ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "toggleIcon"
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-chevron-up': _vm.jobsFilesCompensatedToggle[joI], 'fa-chevron-down': !_vm.jobsFilesCompensatedToggle[joI]
      }
    })])]) : _vm._e(), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && _vm.jobsFilesCompensatedToggle[joI]) ? _vm._l((jobOutput.outputFiles), function(outputFile, ofI) {
      return (!outputFile.name.match(/\.json$/) && (_vm.subscription || jobOutput.paidfor)) ? _c('div', {
        key: "compensated" + ofI,
        staticStyle: {
          "margin-left": "40px"
        }
      }, [(outputFile.name.match(/^1_.*_0m\.stl$/) && outputFile.name.match(/_compensated_0m\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                        Support Structure\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [_c('dropdown', {
        attrs: {
          "position": ['center', 'top', 'center', 'top'],
          "visible": !!(_vm.jobsFilesSupportCompensatedVisible[joI])
        },
        on: {
          "clickout": function($event) {
            return _vm.visibleJobsFilesSupportCompensated(joI, false)
          }
        }
      }, [_c('div', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.visibleJobsFilesSupportCompensated(joI, true)
          }
        }
      }, [_vm._v("\n                                Download "), _c('i', {
        staticClass: "fa fa-angle-down"
      })]), _vm._v(" "), _c('div', {
        staticClass: "dialog no-padding",
        attrs: {
          "slot": "dropdown"
        },
        slot: "dropdown"
      }, [_c('aside', {
        staticClass: "menu"
      }, [_c('ul', {
        staticClass: "menu-list"
      }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
        return (outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/) && outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/)) ? _c('li', {
          key: ofNI
        }, [_c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              _vm.fileDownload($event, {
                filename: outputFileNested.name,
                sourceFilePathKey: _vm.job.sourceFilePathKey,
                jobPathKey: _vm.job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              });
              _vm.visibleJobsFilesSupportCompensated(joI, false)
            }
          }
        }, [_vm._v("\n                                                Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                            ")])]) : _vm._e()
      }), 0)])])])], 1)]) : (outputFile.name.match(/output_compensated\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                        Oriented Part\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [(_vm.isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)) ? _c('button', {
        staticClass: "a3d btn inv small",
        on: {
          "click": function($event) {
            return _vm.showEstimateCost($event, {
              filename: 'cost.json',
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), _c('dropdown', {
        attrs: {
          "position": ['center', 'top', 'center', 'top'],
          "visible": !!(_vm.jobsFilesPartCompensatedVisible[joI])
        },
        on: {
          "clickout": function($event) {
            return _vm.visibleJobsFilesPartCompensated(joI, false)
          }
        }
      }, [_c('div', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.visibleJobsFilesPartCompensated(joI, true)
          }
        }
      }, [_vm._v("\n                                Download "), _c('i', {
        staticClass: "fa fa-angle-down"
      })]), _vm._v(" "), _c('div', {
        staticClass: "dialog no-padding",
        attrs: {
          "slot": "dropdown"
        },
        slot: "dropdown"
      }, [_c('aside', {
        staticClass: "menu"
      }, [_c('ul', {
        staticClass: "menu-list"
      }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
        return (outputFileNested.name.match(/output_compensated\.[\S]{3}$/)) ? _c('li', {
          key: ofNI
        }, [_c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              _vm.fileDownload($event, {
                filename: outputFileNested.name,
                sourceFilePathKey: _vm.job.sourceFilePathKey,
                jobPathKey: _vm.job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              });
              _vm.visibleJobsFilesPartCompensated(joI, false)
            }
          }
        }, [_vm._v("\n                                                Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                            ")])]) : _vm._e()
      }), 0)])])])], 1)]) : _vm._e()]) : _vm._e()
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.job.nestedJobs), function(jobNested) {
      return (_vm.job.nestedJobs) ? _c('div', {
        key: jobNested.id
      }, [_c('job-output', {
        attrs: {
          "job": jobNested,
          "compare-mode": _vm.compareMode
        }
      })], 1) : _vm._e()
    })], 2) : _vm._e()
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1em",
      "height": "1px"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3cf5c9a2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf5c9a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Files/JobOutput.vue
// module id = 480
// module chunks = 1